import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { tournamentService } from '@/services/tournament';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useTournamentLeaderboardMedal() {
    const route = useRoute();
    const crudAction = useCrudActions();

    const leaderboardItemId = route.params.id;
    const model = reactive({
        linkedItems: [],
        unlinkedItems: []
    });

    const { fetchList, list, total } = useBaseListView({
        request: tournamentService.medal.getLinked,
        paramsBuilder: () => ({ leaderboardItemId }),
        hooks: {
            onSuccess: () => {
                model.linkedItems = [];
                model.unlinkedItems = [];

                list.value.forEach(medal => {
                    if (medal.linkedLeaderboard) {
                        model.linkedItems.push(medal.id);
                    } else {
                        model.unlinkedItems.push(medal.id);
                    }
                });
            }
        }
    });

    const actions = {
        link: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you wanna link this medal?',
            request: medalId => tournamentService.medal.link(leaderboardItemId, medalId),
            onSuccess: () => fetchList()
        }),
        unlink: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you wanna unlink this medal?',
            request: medalId => tournamentService.medal.unlink(leaderboardItemId, medalId),
            onSuccess: () => fetchList()
        }),
        linkAll: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to link all medals?',
            request: () => tournamentService.medal.link(leaderboardItemId, model.unlinkedItems.join(',')),
            onSuccess: () => fetchList()
        }),
        unlinkAll: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to unlink all medals?',
            request: () => tournamentService.medal.unlink(leaderboardItemId, model.linkedItems.join(',')),
            onSuccess: () => fetchList()
        })
    };

    return { model, fetchList, total, list, actions };
}
